import { errorViewRoute } from "@/router";
import { createSlice } from "@reduxjs/toolkit";
export const locationSlice = createSlice({
  name: "locationSpace",
  initialState: {
    locationState: {},
  },
  reducers: {},
});

let fetchLocationData = async (params: any = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      let resData = await homeApi.queryLocation(params);
      resolve(resData.data);
    } catch (err: any) {
      window.location.hash = errorViewRoute.path + `?errorMessage=${encodeURIComponent(err.message)}`;
      reject(err);
    }
  });
};

export { fetchLocationData };
export const locationStateSelector = (state: any) => state.locationReducer.locationState;
export default locationSlice.reducer;
